import React, { useState, useEffect, useRef, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import { AiOutlinePrinter } from 'react-icons/ai';
import { FaRegEye } from 'react-icons/fa6';
import { IoAddSharp } from 'react-icons/io5';
import Pagination from '../pagination/pagination';
import { clearRows } from '../../../Redux/actions/rowActions';
import { GrEdit } from 'react-icons/gr';
import { useDispatch } from 'react-redux';
const DirectPurchaseList = ({ onRequisitionData, itemData }) => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const REPORT_URL = process.env.REACT_APP_REPORTS_URL;
  const [selectedRow, setSelectedRow] = useState(null);
  let navigate = useNavigate();
  const gridRef = useRef();
  const [pageSize, setPageSize] = useState(20);
  const apiService = new ApiService();
  const [selectedtem, setSelectedItem] = useState(null);
  const [permissions, setPermissions] = useState([]);
  let dispatch = useDispatch();
  const [pagination, setPagination] = useState();
  useEffect(() => {
    // getItems();
    const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    const permissions = storedPermissions?.filter((acc) => acc.formName === 'Direct Purchase Kanoo' || acc.formName === 'Direct Purchase');
    setPermissions(permissions[0]);
  }, []);

  const handleEdit = () => {
    let eye = false;
    if (selectedRow?.grnNo) {
      const updatedData = { ...selectedRow, eye: eye };
      if (updatedData?.status === 1) {
        const updatedData = { ...selectedRow, eye: !selectedRow.eye?.active };
        navigate(`/Inventory/DirectPurchaseKanoo/${updatedData?.grnNo}`, { state: updatedData });
      } else {
        dispatch(clearRows());
        navigate('/Inventory/DirectPurchaseKanoo/Create', { state: selectedRow });
      }
    }
  };
  const handlePrint = () => {
    if (selectedRow) {
      const token = localStorage.getItem('Token');
      const DB = localStorage.getItem('DataBase');
      if (!token) {
        alert('Auth token is missing! Unable to proceed.');
        return;
      }
      const popupWidth = 1000;
      const popupHeight = 600;
      const popupLeft = (window.screen.width - popupWidth) / 2;
      const popupTop = (window.screen.height - popupHeight) / 2;
      const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

      if (popup) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = REPORT_URL;
        form.target = 'ReportPopup';

        const inputs = [
          { name: 'authToken', value: token },
          { name: '_db', value: DB },
          { name: 'reportName', value: 'DirectPurchase' },
          { name: 'voucherNo', value: selectedRow?.grnNo },
        ];

        inputs.forEach(({ name, value }) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
      // dispatch(clearRows());
      // navigate(`/Inventory/GRN/${selectedRow?.grnNo}`, { state: selectedRow })
    }
  };
  const handleEye = (clickedRowData) => {
    let eye = true;
    if (clickedRowData?.grnNo) {
      dispatch(clearRows());
      const updatedData = { ...clickedRowData, eye: eye };
      navigate(`/Inventory/DirectPurchase/${updatedData?.grnNo}`, { state: updatedData });
    } else {
      dispatch(clearRows());
      const updatedData = { ...selectedRow, eye: eye };
      navigate(`/Inventory/DirectPurchase/${selectedRow?.grnNo}`, { state: updatedData });
    }
  };
  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      params.append('TransportMode', 'Direct');
      const res = await apiService.getApiParamater('GET_PO', `?${params.toString()}`);
      let responseSort = res?.data?.result;
      // const grnData = responseSort?.filter(dep => dep.grnNo === dep?.pOrderNo)
      setPagination(res.data.paginationData);
      setRowData(responseSort || []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching items:', error);
      setLoading(false);
    }
  };
  const dateFormatter = (params) => {
    if (!params.value) return '';
    const date = moment(params.value);
    return date.isValid() ? date.format('DD-MMM-YYYY') : '';
  };
  const dateComparator = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
  };
  const columnDefs = [
    { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
    { headerName: 'DP GRN No', field: 'grnNo', suppressMovable: true, width: 150 },
    { headerName: 'Supplier ID', field: 'vendorId', suppressMovable: true },
    {
      headerName: 'Invoice Date',
      field: 'invoiceDate',
      suppressMovable: true,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
    },
    { headerName: 'Invoice No', field: 'invoiceNo', suppressMovable: true },
    { headerName: 'Location', field: 'warehouse', suppressMovable: true },
    { headerName: 'Property', field: 'costCenter1', suppressMovable: true },
    { headerName: 'Unit', field: 'costCenter2', suppressMovable: true },
    {
      headerName: 'Status',
      field: 'status',
      suppressMovable: true,
      cellRenderer: function (params) {
        if (params.value === 0 || params.value === null) {
          return <button class="btn pend ">Pending</button>;
        } else if (params.value === 1 || params.value === null) {
          return <button class="btn aproved">Approved</button>;
        } else if (params.value === 5 || params.value === null) {
          return <button class="btn hold">Hold</button>;
        } else if (params.value === 2 || params.value === null) {
          return <button class="btn reject">Rejected</button>;
        } else if (params.value === 3 || params.value === null) {
          return <button class="btn aproved">Approved</button>;
        } else {
          return params.value;
        }
      },
    },
  ];
  const clearAllRows = () => {
    dispatch(clearRows());
  };
  const handlenew = () => {
    clearAllRows();
    navigate('/Inventory/DirectPurchaseKanoo/Create');
  };
  const onCellClicked = (event) => {
    if (event.colDef.field === 'grnNo') {
      dispatch(clearRows());
      const clickedRowData = event.data;
      handleEye(clickedRowData);
    }
  };
  const onSelectionChanged = async (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
    const params = new URLSearchParams();
    params.append('DocNo', selectedRows[0]?.grnNo);
    params.append('DocumentType', 'Direct Purchase');
    try {
      const res = await apiService.getApiParamater('GET_EDITABLE_DOC', `?${params.toString()}`);
      const statuses = res?.data?.result?.map((item) => item.status);
      const allAreZero = statuses.every((status) => status === 0);
      const anyIsFive = statuses.some((status) => status === 2);
      if (allAreZero || anyIsFive) {
        setSelectedItem(selectedRows.length === 1 ? selectedRows[0] : null);
      } else {
        console.warn('No valid status to set the item.');
        setSelectedItem(null);
      }
    } catch (error) {
      setSelectedItem(null);
      console.error('Error fetching document status:', error);
    }
  };
  return (
    <div className="p-4">
      <div className="border-box2 p-4 justify-content-between pb-3 d-flex align-items-center">
        <h4 className="mainInvHead">Direct Purchase Kanoo List</h4>
        <div className="d-flex justify-content-end gap-1">
          <div
            onClick={handleEye}
            className={`mainbtnGry flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
            style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
          >
            <FaRegEye color="#fff" className="center mt-1" />
            <div className="center">View</div>
          </div>
          {permissions?.canUpdate === true ? (
            <div
              onClick={(selectedtem && selectedtem?.status === 0) || selectedtem?.status === 2 ? handleEdit : null}
              className={`mainbtnSecondary flex-end gap-2 ${!selectedtem || selectedtem?.status === 0 || selectedtem?.status === 2 ? '' : 'disabled'}`}
              style={{
                cursor: (selectedtem && selectedtem?.status === 0) || selectedtem?.status === 2 ? 'pointer' : 'not-allowed',
              }}
            >
              <GrEdit color="#fff" className="center mt-1 " />
              <div className="center">Edit</div>
            </div>
          ) : (
            ''
          )}
          <div
            onClick={handlePrint}
            className={`mainbtnRed flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
            style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
          >
            <AiOutlinePrinter color="#fff" className="center mt-1 mx-2" />
            <div className="center">Print</div>
          </div>
          {permissions?.canAdd === true ? (
            <div className="col center">
              <button className="mainbtn " type="submit" onClick={() => handlenew()}>
                <IoAddSharp color="#fff" className="center mt-1" /> <div>Add</div>
              </button>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="gridshad">
        <div className="ag-theme-quartz " style={{ height: 650 }}>
          <AgGridReact
            getRowStyle={(params) => {
              if (params.node.rowIndex % 2 === 0) {
                return { background: '#F0EDF5' };
              } else {
                return { background: '#fff' };
              }
            }}
            rowData={rowData}
            enableFilter={true}
            floatingFilter={true}
            columnDefs={columnDefs}
            onCellClicked={onCellClicked}
            onSelectionChanged={onSelectionChanged}
          />
        </div>
      </div>
      <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
    </div>
  );
};
export default DirectPurchaseList;
